import React, { Component } from "react";
import { connect } from "react-redux";
import { makeRegistrationRequest } from "../../redux/Auth/authActions";
import { AppColumn } from "../UI/Layouts";
import RegistrationStepperComponent from "../Modals/Registration/RegistrationStepperComponent";
import { logUserAction } from "../../utils/analyticsFunctions";
import UserActions from "../../utils/Constants/UserActions";
import { closeModal, openModal } from "../../redux/Modals/ModalActions";
import AppFooter from "../Footers/AppFooter";
import { SizedBox } from "../UI/Sizes";
import CircularLoader from "../UI/LoadingIndicators/CircularLoadingIndicators";
import AppText from "../UI/Texts/AppTexts";
import { t } from "i18next";
import { USER_ACCOUNT } from "../../utils/Constants/Paths";
import { showToast } from "../../redux/Snackbar/SnackbarActions";
import UnifiedRegistrationFormV2 from "../Modals/Registration/Sections/UnifiedRegistrationFormV2";

class RegistrationPage extends Component {
  state = {
    idToken: null,
    targetPath: null,
    initialEmail: "",
  };

  componentDidMount() {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const idToken = urlParams.get("id_token");
    const targetPath = urlParams.get("target_path");
    const initialEmail = urlParams.get("email")?.trim().toLowerCase() || "";

    this.setState({
      idToken: idToken,
      targetPath: targetPath || USER_ACCOUNT,
      initialEmail,
    });

    if (idToken) {
      this.props.makeRegistrationRequest(idToken, null, targetPath);
    } else {
      logUserAction(UserActions.registration_getstarted);
    }
  }

  render() {
    const {
      deviceDetails,
      auth,
      openModal,
      closeModal,
      asModal = false,
    } = this.props;

    const { idToken, targetPath, initialEmail } = this.state;

    const { isMobile } = deviceDetails;

    const hasToken = idToken && idToken.length > 0;

    const isLoading = hasToken || (hasToken && auth.authLoading);

    if (isLoading) {
      return (
        <AppColumn
          style={{
            height: "100vh",
            padding: this.props.theme.spacing.contentPadding,
          }}
          mainAxisAlignment={"center"}
          crossAxisAlignment={"center"}
        >
          <CircularLoader
            style={{
              height: "40px",
              width: "40px",
            }}
          />
          <SizedBox height={this.props.theme.spacing.elementPadding} />
          <AppText.Caption
            use={"h2"}
            color={this.props.theme.colors.grey}
            margins={{
              marginBottom: "0px",
              marginTop: "0px",
            }}
            center
          >
            {hasToken ? t("register.auth.waiting") : t("loading")}
          </AppText.Caption>
        </AppColumn>
      );
    }

    if (asModal) {
      return <UnifiedRegistrationFormV2 closeModal={closeModal} asModal={true} />;
    }

    const pageContent = (
      <RegistrationStepperComponent
        openModal={openModal}
        closeModal={closeModal}
        showToast={this.props.showToast}
        targetPath={targetPath}
        initialEmail={initialEmail}
        asModal={asModal}
      />
    );

    if (isMobile) {
      return (
        <AppColumn>
          <div
            style={{
              margin: "0",
              padding: "0",
              top: "0",
              minHeight: "100vh",
              width: "100%",
              flex: 1,
            }}
          >
            {pageContent}
            <SizedBox height={this.props.theme.spacing.contentPaddingBig} />
          </div>
          <AppFooter forceShow />
        </AppColumn>)
    }

    return (
      <AppColumn>
        <div
          style={{
            margin: "0",
            padding: "0",
            top: "0",
            height: "100%",
            width: "100%",
            marginTop: "0px",
            backgroundColor: this.props.theme.primaryColor,
            transform: "none",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(120deg, #318686 30%, #6b2727 100%)",
          }}
        >
          <AppColumn
            crossAxisAlignment={"center"}
            mainAxisAlignment={"center"}
            style={{
              height: "100vh",
            }}
          >
            <AppColumn
              style={{
                height: isMobile ? "100%" : "90vh",
                width: isMobile ? "100%" : "50%",
                backgroundColor: this.props.theme.colors.white,
                borderRadius: isMobile ? "0px" : this.props.theme.radius.default,
              }}
            >
              {pageContent}
              
              <SizedBox height={this.props.theme.spacing.contentPaddingBig} />
            </AppColumn>
          </AppColumn>
        </div>
        <AppFooter forceShow />
      </AppColumn>
    );
  }
}

export default connect(
  (state) => {
    return {
      auth: state.auth,
      deviceDetails: state.core.deviceDetails,
      theme: state.theme,
    };
  },
  {
    makeRegistrationRequest,
    openModal,
    closeModal,
    showToast,
  }
)(RegistrationPage);
